import React from "react";
import { useNavigate } from "react-router-dom";
import "../css/HolisticPillars.css";

const HolisticPillars = () => {
  const navigate = useNavigate();
  const pillarsData = [
    { id: 1, title: "Sports Excellence", icon: "/icon/sports.png" },
    { id: 2, title: "Academic Excellence", icon: "/icon/academic-program.png" },
    { id: 3, title: "Visual & Performing Arts", icon: "/icon/visual-data.png" },
    { id: 4, title: "Personality Development", icon: "/icon/team-leader.png" },
    {
      id: 5,
      title: "Innovation & Creativity",
      icon: "/icon/project-management.png",
    },
    {
      id: 6,
      title: "Entrepreneurship & Leadership",
      icon: "/icon/entrepreneurship.png",
    },
    {
      id: 7,
      title: "Universal Values & Ethics",
      icon: "/icon/universal-studio.png",
    },
    { id: 8, title: "Community & Care", icon: "/icon/team-leader.png" },
    { id: 9, title: "Skill Development", icon: "/icon/audience.png" },
  ];

  return (
    <section className="holistic-pillars-section">
      {}

      <div className="gems-info-section">
        <div className="gems-info-left">
          <span className="gems-tag">Holistic Learning</span>

          <h2>What is 9 Gems?</h2>

          <p>
            The <strong>9 Gems Framework</strong> is Sahara Public School's
            holistic learning model designed to nurture every aspect of a
            child's growth. Rather than focusing only on academics, it
            encourages students to develop physically, emotionally, creatively,
            socially and intellectually.
          </p>

          <p>
            Through sports, leadership opportunities, creative arts, innovation
            projects, ethics, community service and skill-based learning, every
            child discovers their strengths and becomes a confident, responsible
            and future-ready individual.
          </p>
         <button
  className="global-btn"
  onClick={() => navigate("/school-gems")}
>
  Read More →
</button>
        </div>

        <div className="gems-info-right">
          <img src="./images/o.jpeg" alt="Students Learning" />
        </div>
      </div>

      {}

      <div id="pillars-section" className="pillars-main-strip">
        {pillarsData.map((pillar) => (
          <div key={pillar.id} className="pillar-single-item">
            <div className="pillar-icon-wrapper">
              <img
                src={pillar.icon}
                alt={pillar.title}
                className="pillar-graphic-img"
              />
            </div>

            <h4 className="pillar-item-title">{pillar.title}</h4>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HolisticPillars;
